import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  margin-bottom: -10px;
  margin-top: 5px;
`

type RowCountProps = {
  count?: number
}

const RowCount = (props: RowCountProps): React.ReactElement => {
  const { count = 0 } = props

  return (
    <Wrapper className="text-muted px-2">
      {i18n.t('data_records', { defaultValue: '{{count}} Einträge', count })}
    </Wrapper>
  )
}

export default RowCount
